export const formatAuditAction = (action: string) =>
    action.toLowerCase().split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
